module.exports = __webpack_public_path__ + "img/icon-pen.f23103c7.svg";